import { RoleLoginPage } from "@/pages/RoleLoginPage";

export const BoothAuthPage = ({ onLogin }) => {
  return <RoleLoginPage role="booth_incharge" onLogin={onLogin} />;
};
